import {
  createTableCellActionsInput,
  type SelectionUiInteraction,
  type SharedEventLoop,
} from '@databases/selections';
import { DatabaseLayoutType } from '@databases/types/database/view';
import { TABLE_V2_LAYOUT_ID } from '@databases/view-layout-table-v2/id';

import {
  type SelectionInputFeature,
  SelectionFeatureKeys,
} from '../../features/types.ts';

/**
 * Dependencies required to wire table cell-action keyboard handling into a mode.
 */
export interface TableCellActionsKeyboardInputFeatureDeps {
  sharedLoop: SharedEventLoop;
  onSelectionUiInteraction?: (event: SelectionUiInteraction) => void;
}

/**
 * Registers the default table keyboard input for Table V1 focused-cell actions.
 *
 * Table V2 also needs Escape/deselect. Edit and clear requests still pass through
 * reducer policy; registering this input does not enable mutation effects.
 */
export function createTableCellActionsKeyboardInputFeature(
  deps: TableCellActionsKeyboardInputFeatureDeps,
): SelectionInputFeature {
  return {
    key: SelectionFeatureKeys.TABLE_CELL_ACTIONS_KEYBOARD_INPUT,
    type: 'input',
    isEnabled: (ctx) =>
      ctx.layoutType === DatabaseLayoutType.TABLE ||
      ctx.layoutType === TABLE_V2_LAYOUT_ID,
    factory: (machine) =>
      createTableCellActionsInput(machine, deps.sharedLoop, {
        onSelectionUiInteraction: deps.onSelectionUiInteraction,
      }),
  };
}
